// 메뉴관리(SY11) 화면 상수 — 배선(index.tsx)·검증(validate.ts)이 쓰는 문구·규칙.

/** 상위메뉴 최상위 값 — 1.0 MOMS_MENU_INFO.MENU_TREE 가 쓰는 루트 표기 */
export const MENU_TREE_ROOT = 'root'

/** 순서(MENU_ORD) 형식 — FOLD 메뉴는 `8` 같은 단일 숫자, 하위는 `1-3-1` 같은 여러 단이라 단 수를 고정하지 않는다(LOGISPRD-16595 BE 검증과 같은 규칙). */
export const MENU_ORDER_PATTERN = /^\d+(-\d+)*$/

/** 메뉴코드 형식 — 대문자로 시작하는 대문자·숫자·_, ROOT 불가(LOGISPRD-16595 SystemMenuController MENU_CODE_PATTERN). DB 비교가 대소문자를 무시해(utf8mb4_general_ci) 대문자로만 받는다. */
export const MENU_CODE_PATTERN = /^(?!ROOT$)[A-Z][A-Z0-9_]*$/

/**
 * 칸별 최대 길이 — 넘으면 BE 가 400 을 준다(LOGISPRD-16595). 순차 저장이 중간에 멈추지 않게 저장 전에 막는다.
 * 메뉴코드는 MOMS_MENU_INFO(20)가 아니라 같은 값을 받는 MOMS_PROG_INFO·MOMS_USER_ACCESS_LOG 등의 길이(10)에 맞춘 BE 제한이다.
 */
export const MENU_MAX_LENGTH = { MENU_CD: 10, MENU_NM: 200, MENU_TREE: 100, MENU_ORD: 10 } as const

/** 표 페이지 크기 — '몇 개씩' 미노출 = 10,000개씩(MOMS·MWMS 공통 규칙 2026-08-24) */
export const SY11_PAGE_SIZE = 10000

export const MESSAGES = {
  noSelection: '저장할 행을 선택해 주세요.',
  requiredCells: '메뉴코드·메뉴명·메뉴종류·상위메뉴·순서를 모두 입력하세요.',
  invalidType: '메뉴종류는 FOLD·PROG 중에서 골라 주세요.',
  invalidCode: '메뉴코드는 대문자로 시작하고 대문자·숫자·_ 만 입력해 주세요. ROOT 는 쓸 수 없습니다.',
  invalidTree:
    '폴더(FOLD)의 상위메뉴는 root, 화면(PROG)의 상위메뉴는 저장된 root 아래 폴더 중에서 골라 주세요. 새 폴더는 먼저 저장한 뒤 고를 수 있습니다.',
  folderHasChildren: '하위 메뉴가 있는 폴더는 메뉴종류를 바꿀 수 없습니다.',
  deleteFolderHasChildren: '하위 메뉴가 있는 폴더는 삭제할 수 없습니다. 하위 메뉴를 먼저 삭제하거나 다른 폴더로 옮겨 주세요.',
  invalidOrder: '순서는 8, 1-1, 1-3-1 형식으로 입력해 주세요.',
  tooLong: `새 행의 메뉴코드는 ${MENU_MAX_LENGTH.MENU_CD}자, 메뉴명은 ${MENU_MAX_LENGTH.MENU_NM}자, 상위메뉴는 ${MENU_MAX_LENGTH.MENU_TREE}자, 순서는 ${MENU_MAX_LENGTH.MENU_ORD}자까지 입력할 수 있습니다.`,
  duplicateCode: '이미 있거나 다른 새 행과 겹치는 메뉴코드입니다. 새 행의 메뉴코드를 바꿔 주세요.',
  /** 행별 순차 처리 중 실패 — 실패 지점에서 멈추므로 앞의 done 건은 이미 반영됐다. */
  partialFailed: (total: number, done: number, reason: string) => `${total}건 중 ${done}건 반영 후 실패했습니다. ${reason}`,
} as const
